import htmlLogo from "../../../../assets/logos/html-5-svgrepo-com.svg";
import cssLogo from "../../../../assets/logos/css-3-svgrepo-com.svg";
import jsLogo from "../../../../assets/logos/js-svgrepo-com.svg";
import reactLogo from "../../../../assets/logos/react-svgrepo-com.svg";
import twLogo from "../../../../assets/logos/tailwind-svgrepo-com.svg";
import muLogo from "../../../../assets/logos/material-ui-svgrepo-com.svg";
import antdLogo from "../../../../assets/logos/ant-design-svgrepo-com.svg";

const logos = [
  {
    url: htmlLogo,
    title: "HTML Logo",
  },
  {
    url: cssLogo,
    title: "CSS Logo",
  },
  {
    url: jsLogo,
    title: "Javascript Logo",
  },
  {
    url: reactLogo,
    title: "ReactJs Logo",
  },
  {
    url: twLogo,
    title: "Tailwind Logo",
  },
  {
    url: muLogo,
    title: "Material UI Logo",
  },
  {
    url: antdLogo,
    title: "Ant Design Logo",
  },
];

export default logos;
